module.exports = __webpack_public_path__ + "73dffca51454a6c1f6ea7f10c3cf3ee2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-7.svg
// module id = 491
// module chunks = 0